import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';

import {
  Typography as Typo
} from '@mui/material';

var he = require('he');

type TypographyProps = {
  sx?: object;
  onClick?: (e:unknown) => void;
  children: React.ReactNode | string;
  html?: boolean;
  clean?: boolean;
  noWrap?: boolean;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined;
};

export const Typography: FunctionComponent<TypographyProps> = ({variant, sx, children, onClick, html, noWrap, clean}) => {
  const theme = useTheme();

  return (!!html && typeof(children) === "string" ? <Typo
    variant={variant}
    noWrap={noWrap}
    sx={{
      "a": {
        color: theme.palette.primary.main,
        textDecoration: 'none'
      },
      "a:hover": {
        textDecoration: 'underline'
      },
      // marginBlockStart: '6px',
      // marginBlockEnd: '6px',
      // "& p": {
      //   marginBlockStart: '6px',
      //   marginBlockEnd: '6px',
      // },
      ...(!!clean ? {
        backgroundColor: 'transparent !important',
        fontFamily: 'Nunito, sans-serif !important',
        "& p": {
          backgroundColor: 'transparent !important',
          fontFamily: 'Nunito, sans-serif !important',
        },
        "& span": {
          backgroundColor: 'transparent !important',
          fontFamily: 'Nunito, sans-serif !important',
        }
      } : {}),
      ...sx
    }}
    onClick={(e) => {if (!!onClick) onClick(e);}}
    dangerouslySetInnerHTML={{ __html: children }}
  ></Typo> : <Typo
    noWrap={noWrap}
    variant={variant}
    sx={{
      "a": {
        color: theme.palette.primary.main,
        textDecoration: 'none'
      },
      "a:hover": {
        textDecoration: 'underline'
      },
      // marginBlockStart: '6px',
      // marginBlockEnd: '6px',
      // "& p": {
      //   marginBlockStart: '6px',
      //   marginBlockEnd: '6px',
      // },
      ...sx
    }}
    onClick={(e) => {if (!!onClick) onClick(e);}}
  >
    {typeof(children) === "string" ? he.decode(children.replace(/<[^>]*>?/gm, '')) : children}
  </Typo>);
}